// extracted by mini-css-extract-plugin
export default {"notFull":"ReadMore_notFull__-RsoP","full":"ReadMore_full__b49ce"};